import type { SiteClass } from "../types/input";

const SS_COLS = [0.25, 0.5, 0.75, 1.0, 1.25, 1.5];
const FS_TABLE: Record<SiteClass, number[]> = {
  ZA: [0.8, 0.8, 0.8, 0.8, 0.8, 0.8],
  ZB: [0.9, 0.9, 0.9, 0.9, 0.9, 0.9],
  ZC: [1.3, 1.3, 1.2, 1.2, 1.2, 1.2],
  ZD: [1.6, 1.4, 1.2, 1.1, 1.0, 1.0],
  ZE: [2.4, 1.7, 1.3, 1.1, 0.9, 0.8],
};
const S1_COLS = [0.1, 0.2, 0.3, 0.4, 0.5, 0.6];
const F1_TABLE: Record<SiteClass, number[]> = {
  ZA: [0.8, 0.8, 0.8, 0.8, 0.8, 0.8],
  ZB: [0.8, 0.8, 0.8, 0.8, 0.8, 0.8],
  ZC: [1.5, 1.5, 1.5, 1.5, 1.5, 1.4],
  ZD: [2.4, 2.2, 2.0, 1.9, 1.8, 1.7],
  ZE: [4.2, 3.3, 2.8, 2.4, 2.2, 2.0],
};

function interp(cols: number[], row: number[], x: number): number {
  if (x <= cols[0]!) return row[0]!;
  const last = cols.length - 1;
  if (x >= cols[last]!) return row[last]!;
  for (let i = 0; i < last; i++) {
    const x0 = cols[i]!, x1 = cols[i + 1]!;
    if (x >= x0 && x <= x1) return row[i]! + ((x - x0) / (x1 - x0)) * (row[i + 1]! - row[i]!);
  }
  return row[last]!;
}

/** TBDY 2018 Tablo 2.1 — kısa periyot yerel zemin etki katsayısı FS. */
export const siteFactorFS = (siteClass: SiteClass, SS: number): number => interp(SS_COLS, FS_TABLE[siteClass], SS);
/** TBDY 2018 Tablo 2.2 — 1,0 s periyot yerel zemin etki katsayısı F1. */
export const siteFactorF1 = (siteClass: SiteClass, S1: number): number => interp(S1_COLS, F1_TABLE[siteClass], S1);
